import { Injectable } from '@angular/core';
import { ApiService } from 'app/core/services/api.service';
import { Tipologia } from 'app/modules/models/tipologia.model';

@Injectable({providedIn: 'root'})
export class CatalogosService {
    constructor(private api: ApiService) { }

    CrearTipologia(tipologia: Tipologia){
        const url = `/tipologias`
        return new Promise((resolve, reject) => {
            this.api.PostMethod(url, tipologia, {}, 'Error al Guardar Catálogo')
                .subscribe( (response: any) => {
                    if (response?.isSuccess) {
                        this.api.showSuccessMessage(response?.message);
                    }
                    resolve(response);
                }, error => reject(error))
        })
    }

    actualizarTipologia(tipologia: Tipologia){
        const url = `/tipologias/${tipologia.tipologiaId}`
        return new Promise((resolve, reject) => {
            this.api.PutMethod(url, tipologia, {}, 'Error al actualizar Catálogo')
                .subscribe( (response: any) => {
                    if (response?.isSuccess) {
                        this.api.showSuccessMessage(response?.message);
                    }
                    resolve(response);
                }, error => reject(error))
        })
    }

    eliminarTipologia(tipologiaId: number){
        const url = `/tipologias/${tipologiaId}`
        return new Promise((resolve, reject) => {
            this.api.DeleteMethod(url, {}, 'Error al eliminar Catálogo')
                .subscribe( (response: any) => {
                    if (response?.isSuccess) {
                        this.api.showSuccessMessage(response?.message);
                    }
                    resolve(response);
                }, error => reject(error))
        })
    }

}
